import { useState, useEffect } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const Projects = () => {

    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
      return setTimeout(() => {
        setLetterClass('text-animate-hover')
      }, 3000)
    }, [])
    
    return(
        <>
            <div class="container project-page">
                <div className='featured'>
                    <div className='text-zone'>
                        <h1>
                            <AnimatedLetters
                            letterClass={letterClass}
                            strArray={['P', 'r', 'o', 'j', 'e', 'c', 't', 's']}
                            idx={15}
                            />
                        </h1>
                        <p className='featured-text'>Personal Projects, just click on them and you can visit the repo!</p>
                    </div>
                    <div className='contain'>
                        <a href="https://github.com/Manjellion/GeoExploration_MERN" target="_blank"><img src="https://media.istockphoto.com/vectors/application-on-smartphone-screen-line-illustration-vector-id802556994?k=20&m=802556994&s=612x612&w=0&h=V_QAxKUdGL8l2cqHLLYnqqRJ6Hft3a6tr7Uyri2j1fA=" alt='' /></a>
                        <a href="https://github.com/Manjellion/AWSAmplify-taxiApp" target="_blank"><img src="https://i.pinimg.com/originals/26/d7/a3/26d7a3e9ab92490c083ddeee6726baa6.jpg" alt='' /></a>
                        <a href="https://github.com/Manjellion/carkPark-system" target="_blank"><img src="https://media.istockphoto.com/vectors/parking-smartphone-app-public-carpark-urban-transport-tiny-woman-for-vector-id1329339754" alt='' /></a>
                        <a href="https://github.com/Manjellion/crypto-tracker" target="_blank"><img src="https://static.toiimg.com/thumb/msid-86636722,imgsize-31528,width-400,resizemode-4/86636722.jpg" alt='' /></a>
                        <a href="https://github.com/Manjellion/CW-covid-Tracker-webApp-uni" target="_blank"><img src="https://www.synopsys.com/blogs/software-security/wp-content/uploads/2020/08/TrackTrace.jpg" alt='' /></a>
                        <a href="https://github.com/Manjellion/cw-restAPI" target="_blank"><img src="https://i.pinimg.com/originals/af/0a/bb/af0abbe07f354fc5631c9ea1d6a9f33c.jpg" alt='' /></a>
                        <a href="https://github.com/Manjellion/Youtube-Command-line-appliaction" target="_blank"><img src="https://media.istockphoto.com/vectors/podcast-concept-equipment-for-blogging-webcasting-and-broadcasting-vector-id1285018978?k=20&m=1285018978&s=612x612&w=0&h=CXNam9c-32NGnnZlcLD7YXoBy25dUvWxvFaA7aB5gPM=" alt='' /></a>
                        <a href="https://github.com/Manjellion/Weather.app" target="_blank"><img src="https://i.pinimg.com/originals/d9/d2/82/d9d282bfd1842ef06e706a12679e7e49.jpg" alt='' /></a>
                        <a href="https://github.com/Manjellion/TradingBot-Project"><img src="https://thumbs.dreamstime.com/b/modern-flat-design-concept-cryptocurrency-trading-bot-illustration-websites-landing-pages-mobile-applications-posters-229575099.jpg" alt='' /></a>
                    </div>
                </div>
            </div>
            
            <Loader type='pacman' />
        </>
        
        
    )
}

export default Projects;